import React from "react";
import {Link} from "react-router-dom";

import {ReferenceLabelViewComponent} from "ppm-react-references";
import {REFERENCE_LABELS_API_URL} from "../../helpers/api-urls";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import AuthorizationChecker from "security/AuthorizationChecker";
import { withTranslation } from "react-i18next";

const PagesDetailReferenceLabels = (props) =>{
    const {referenceId,referenceValueId, referenceLabelId} = props;
    const baseUrl = "/pages-references/"+referenceId+"/"+referenceValueId
    return ( 
        <>
            <div className="page-content">
                
                    <title>{props.t("REFERENCE_LABEL")}</title>
                
                <div className="mb-4">
                    <Breadcrumbs title={props.t("REFERENCE_LABEL")} breadcrumbItem={props.t("REFERENCE_LABEL_DETAIL")}/>
                    <Link className="btn btn-info" to={baseUrl}>{props.t("RETURN_TO_LIST")}</Link>

                    { AuthorizationChecker.isGranted(["EDIT_REFERENCE_LABELS"]) && ( <Link className="btn btn-info ms-3" to={baseUrl+"/"+referenceLabelId+"/edit"}>{props.t("EDIT")}</Link> )}
                    
                    { AuthorizationChecker.isGranted(["ADD_REFERENCE_LABELS"]) && (<Link className="btn btn-info ms-3" to={baseUrl+"/add"}>{props.t("ADD")}</Link> )}
                </div>
                <ReferenceLabelViewComponent
                    referenceLabelId={referenceLabelId}
                    referenceValueId={referenceValueId}
                    referenceId={referenceId}
                    apiUrl={REFERENCE_LABELS_API_URL}
                    addUrl={baseUrl+"/add"}
                    path={baseUrl}
                />
            </div>
        </>
    );
}

export default withTranslation()(PagesDetailReferenceLabels)
